import React, { useContext } from "react";
import keycloakIDPAdapter from "common/Adapters/IDPAdapter/KeycloakIDPAdapter";
import { getHeaderContents } from "@sia/shared/js/contents/layout";
import { Header } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";

const flagToLinkNameMap = {
  disable_login: "account",
  disable_directory: "directory",
  disable_jobs: "jobs",
  disable_agenda: "agenda",
  disable_valueApp: "valueApp",
  disable_catalog: "catalog",
  disable_wizard: "wizard",
  disable_cloud: "cloud",
  disable_benchmarking: "benchmarking",
  disable_ecom: "ecom",
  disable_shop: "shop",
  disable_term: "term",
  "disable_reference-gallery": "referenceGallery",
};

function filterItemsByDisableFlags(items, disableFlags) {
  const disabledLinkNames = disableFlags
    .map(flag => flagToLinkNameMap[flag])
    .filter(Boolean);
  return {
    ...items,
    appSwitcherLinks: items.appSwitcherLinks.filter(
      link => !disabledLinkNames.includes(link.name)
    ),
  };
}

const HeaderClient = ({
  pathFactory,
  history,
  user,
  menuItems,
  i18n,
  openedHeaderDropdowns,
  setOpenedHeaderDropdowns,
  createLanguageKeyReplacedUrl,
  translate,
  headerUser,
  organizationCode,
  defaultAppSwitcherValue,
  availableLanguages,
  language,
  organisationId,
}) => {
  const { disableFlags } = useContext(GlobalContext);
  const webPlatformUrl = process.env.REACT_APP_WEB_PLATFORM_URL;
  const switcherItems = React.useMemo(() => {
    const prefix = `${webPlatformUrl}/${i18n.language}`;
    const headerContentsConfig = {
      links: {
        account: {
          target: `${prefix}/account`,
          internal: false,
        },
        referenceGallery: {
          target: `${prefix}/reference-gallery`,
          internal: false,
        },
        jobs: { target: `${prefix}/jobs`, internal: false },
        directory: {
          target: `${prefix}/directory/${organisationId ? `?sections=${organisationId}&sort=1` : ""}`,
          internal: false,
        },
        agenda: {
          target: pathFactory.create(`agenda`),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("agenda"));
          },
        },
        catalog: {
          target: pathFactory.create("catalog"),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("catalog"));
          },
        },
        cloud: {
          target: process.env.REACT_APP_CLOUD_IDP_LINK,
        },
      },
    };
    let items = { ...getHeaderContents(headerContentsConfig) };
    if (user?.isMemberTypeGroupOf("corporate")) {
      items = {
        ...items,
        appSwitcherLinks: items.appSwitcherLinks.filter((e) => e.name !== "cloud"),
      };
    }
    items = filterItemsByDisableFlags(items, disableFlags);
    return items;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, organisationId, disableFlags]);
  const isUserLoggedIn = keycloakIDPAdapter.isLoggedIn();
  return (
    <Header
      menuItems={menuItems}
      sharedContents={switcherItems}
      selectedLanguageKey={i18n.language}
      logoLinking={() => history.push("/")}
      openedDropdowns={openedHeaderDropdowns}
      toggleDropdowns={(updatedOpenedDropdowns) => setOpenedHeaderDropdowns(updatedOpenedDropdowns)}
      onChangeLanguage={(languageKey) => {
        localStorage.setItem("sia.webPlatform.languageKey", languageKey);
        let languageKeyReplacedUrl = createLanguageKeyReplacedUrl(languageKey);
        window.location.replace(languageKeyReplacedUrl);
      }}
      onClickLogin={() => {
        window.location.href = keycloakIDPAdapter.createLoginUrl(i18n.language);
      }}
      onClickLogout={() => keycloakIDPAdapter.logout()}
      translate={translate}
      isUserLoggedIn={isUserLoggedIn}
      user={headerUser}
      organizationCode={organizationCode}
      defaultAppSwitcherValue={defaultAppSwitcherValue}
      search={true}
      history={history}
      availableLanguages={availableLanguages}
      lang={language}
      showUser={!disableFlags?.includes("disable_login")}
      showAppSwitcher={switcherItems?.appSwitcherLinks.length > 0}
    />
  );
};

export default HeaderClient;
